export default __webpack_public_path__ + "static/media/sqr_img_2.54c38843.svg";